import { PopupMenu } from 'shared/components/ui/popup-menu';
import styled from 'styled-components';

export const Menu = styled(PopupMenu)`
  max-width: 30.4rem;
`;
